import React from 'react';
import IUniformNode, { deepenKey } from '../../../../../shared/quote-rendering/IUniformNode';
import { IItalicNodeProps } from '../../../../../shared/quote-rendering/UniformNodeFactory';

export default class ItalicNode implements IUniformNode<React.ReactNode>{
    
    constructor(
        private readonly props: IItalicNodeProps<React.ReactNode>
    ) {}

    renderWithManualKey() {
        return <i key={this.props.key} style={this.props.style}>{this.props.children.map(x => x.renderWithManualKey())}</i>
    }

    render(seedKey: string){
        return <i key={seedKey} style={this.props.style}>{this.props.children.map((x,i) => x.render(deepenKey(seedKey, i)))}</i>
    }

}